<template>
<div class="row m-0 my-2 justify-content-between align-items-center">
	<div class="col-auto checkbox m-0 g-0 p-0 me-2 ">
		<input
			v-model="realTimeUpdate"
			type="checkbox"
			@change="subscribeToUpdates()"
		>
		<label class="mx-2">
			Останні {{ timeIntervalPromt(Number(viewportMinutes)) }}
		</label>
	</div>

	<div class="col-auto">
		<from-to-period-form
			v-if="!realTimeUpdate"
			:defaultFrom="defaultFrom()"
			:defaultTo="new Date()"
			@from="(v) => fromTime = v"
			@to="(v) => toTime = v"
			@submit="updateObjectLogTable()"
			:disabled="realTimeUpdate"
		/>
	</div>
</div>
<easy-data-table
	class="data-table"
	table-class-name="customize-table"
	:key="rowsPerPage"
	:headers="tableHeaders"
	:items="tableItems"
	theme-color="rgb(198, 199, 200)"
	sort-by="time"
	sort-type="desc"
	:filter-options="filterOptions"
	:rows-items="[
		easyDataTableRowsPerPage(this.tableHeight),
		40,
		100,
		300,
		500,
		1000
	]"
	:rows-per-page="rowsPerPage"
	rows-per-page-message="записів на сторінці"
	rows-of-page-separator-message=" з "
	:table-min-height="380"
	:table-height="tableHeight"
	:loading="tableItems.length == 0"
	alternating
	buttons-pagination
>
	<!-- If log is empty -->
	<template #empty-message>
		Записів журналу не знайдено
	</template>

	<template #loading>
		<div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
			<span class="visually-hidden">Loading...</span>
		</div>
	</template>

	<!-- Time item customization -->
	<template #item-time="{ time }">
		{{ dateTimeToString(time, false, false, true) }}
		<!-- {{ time.getMilliseconds() }} -->
	</template>

	<!-- Level item customization -->
	<template #item-level="{ level }">
		<span :class="{
			'text-primary': level === 'debug',
			'text-success': level === 'info' || level === 'success',
			'text-warning': level === 'warning',
			'text-danger': level === 'error' || level === 'critical',
		}">
			{{ level }}
		</span>
	</template>

	<!-- Filter to level column -->
	<template #header-level="header">
		<!-- Don't create if criterias is empty because form will empty -->
		<table-filter-checkboxes
			:criterias="logLevelCriterias"
			@checked-criterias="(criterias) => { filters.level = criterias }"
		/>
		{{ header.text }}
	</template>
</easy-data-table>
</template>


<script>
import { useAccontStore } from '@/stores/AccountStore'
import FromToPeriodForm from '@/components/FromToPeriodForm.vue'
import TableFilterCheckboxes from '@/components/TableFilterCheckboxes.vue'
import { LOG_LEVELS, readObjectLog } from '@/api/api.js'
import {
	dateTimeToString,
	subtractMinutesFromNowDate,
	easyDataTableHeight,
	easyDataTableRowsPerPage,

} from '@/helpers.js'


export default {
	updatePeriod: 10000,

	components: {
		FromToPeriodForm,
		TableFilterCheckboxes,
	},

	props: {
		objectId: {
			type: String,
			require: true,
		},

		viewportMinutes: {
			type: Number,
			require: true,
			default: 10,
		}
	},

	setup() {
		const accountStore = useAccontStore()

		return {
			accountStore,
			dateTimeToString,
			easyDataTableHeight,
			easyDataTableRowsPerPage,
		}
	},

	data() {
		return {
			tableHeaders:[
				{ text: "Час", value: "time", sortable: true, width: 160, },
				{ text: "Рівень", value: "level", width: 100, },
				{ text: "Запис", value: "msg" }
			],

			logRecords: [],

			// if true - shows last "viewportMinutes" minutes of log and autoupdates
			realTimeUpdate: true,
			// 
			fromTime: null,
			toTime: null,
			//
			updateInterval: null,
			
			// Filters
			filters: {
				level: [],	// log level
			},
			//
			rowsPerPage: 20,
		}
	},

	created() {
		//
		// this.initLevelFilter()

		//
		this.updateObjectLogTable()
		this.subscribeToUpdates()
	},

	mounted() {
		this.rowsPerPage = 1000 // easyDataTableRowsPerPage(this.tableHeight)
	},

	beforeUnmount() {
		this.unsubscribeFromUpdates()
	},


	methods: {
		defaultFrom() {
			return subtractMinutesFromNowDate(this.viewportMinutes)
		},

		updateObjectLogTable() {
			const tmpRecords = []
			// Read object log
			if (this.realTimeUpdate) {
				this.fromTime = subtractMinutesFromNowDate(this.viewportMinutes)
				this.toTime = new Date()
				readObjectLog(this.objectId, tmpRecords, this.fromTime)
				.then(() => {
					this.logRecords = tmpRecords
				})
			} else {
				readObjectLog(this.objectId, tmpRecords, this.fromTime, this.toTime)
				.then(() => {
					this.logRecords = tmpRecords
				})
			}
		},

		subscribeToUpdates() {
			this.unsubscribeFromUpdates()

			// If no need update
			if (!this.realTimeUpdate) {
				return
			}

			// Updates logs every updatePeriod seconds
			this.updateInterval = setTimeout(() => {
				this.updateObjectLogTable();
				this.subscribeToUpdates();
			},
			this.$options.updatePeriod);
		},

		unsubscribeFromUpdates() {
			// Clear interval if exist
			if (this.updateInterval !== null) {
				clearTimeout(this.updateInterval)
				this.updateInterval = null
			}
		},

		timeIntervalPromt(minutes) {
			if (minutes < 60) {
				return `${minutes} хв`
			} else if (minutes >= 60 && minutes <= 1440) {
				return `${minutes / 60} год`
			} else {
				return "> доби"
			}
		},
	},

	computed: {
		tableHeight() { return easyDataTableHeight() - 45 },

		tableItems() {
			const tableItems = []

			this.logRecords.forEach((record) => {
				tableItems.push({
					"time": record["_time"],
					"level": record["level"],
					"msg": record["_value"],
				})
			})

			return tableItems
		},

		logLevelCriterias() {
			return Object.values(LOG_LEVELS)
		},

		filterOptions() {
			const filterOptionsArray = new Array()
			
			filterOptionsArray.push({
				field: 'level',
				comparison: 'in',
				criteria: this.filters.level,
			})

			return filterOptionsArray;
		},
	},
}
</script>


<style src="@/assets/table.css" scoped></style>
<style scoped>
	form, form input, form label {
		font-size: small;
		font-weight: normal
	}

	.level-debug {
		color: rgb(31, 96, 196)
	}
	.level-info {
		color: rgb(55, 135, 45)
	}
	.level-warning {
		color: rgb(224, 180, 0)
	}
	.level-error {
		color: rgb(250, 100, 0)
	}
	.level-critical {
		color: rgb(196, 22, 42)
	}
</style>